<template>
  <v-snackbar :color="snackBar.type" :timeout="2000" v-model="snackBar.visible">
    <v-icon
      v-if="snackBar.type === eTypeSnackBar.success"
      size="x-large"
      icon="mdi-thumb-up"
    ></v-icon>
    <v-icon v-else size="x-large" icon="mdi-alert-outline"></v-icon>
    {{ t(snackBar.message) }}
  </v-snackbar>
</template>
<script lang="ts" setup>
import { snackBar } from "@/store/useNotificationSnackBar";
import { eTypeSnackBar } from "@/types/ui";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>
